import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(main)/(all)/bonanza/template.tsx");
